export default __webpack_public_path__ + "static/media/seneca.336e0439.svg";